import { render, staticRenderFns } from "./DxCostsDatabase.vue?vue&type=template&id=9e0e74b8&"
import script from "./DxCostsDatabase.vue?vue&type=script&lang=js&"
export * from "./DxCostsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports